/**
 * é¿éäºå®æ¹æä¾çæ¥å¿æå¡çJSåºæä»¶ï¼ç®åçæ¹åæäºtsï¼ä½æ²¡ææ·»å ç¸å³ç±»åå®ä¹
 * åè: https://help.aliyun.com/document_detail/31752.html?spm=5176.product28958.6.587.LK3f0y
 */
export class AliLogTracker {
  uri_: any;
  params_: any;
  httpRequest_: any;

  constructor(host, project, logstore) {
    this.uri_ = 'https://' + project + '.' + host + '/logstores/' + logstore + '/track?APIVersion=0.6.0';
    this.params_ = new Array();
    this.httpRequest_ = new XMLHttpRequest();
  }

  push(key, value) {
    if (!key || !value) {
      return;
    }
    this.params_.push(key);
    this.params_.push(value);
  }

  logger() {
    let url = this.uri_;
    let k = 0;
    while (this.params_.length > 0) {
      if (k % 2 == 0) {
        url += '&' + encodeURIComponent(this.params_.shift());
      } else {
        url += '=' + encodeURIComponent(this.params_.shift());
      }
      ++k;
    }
    try {
      this.httpRequest_.open('GET', url, true);
      this.httpRequest_.send(null);
    } catch (ex) {
      if (window && window.console && typeof window.console.log === 'function') {
        console.log('Failed to log to ali log service because of this exception:\n' + ex);
        console.log('Failed log data:', url);
      }
    }
  }
}
